import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { ChildComponentsModule } from '../components/child-components.module';
import { MainPageComponent} from './main-page.component';
import { SwiperModule } from 'swiper/angular';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgOptimizedImage } from '@angular/common';
import { CommonChildComponentsModule } from '../components/common-components.module'
import { WhyIquantaBestComponent } from '../components/why-iquanta-best/why-iquanta-best.component';
import { CourseCardHomeComponent } from '../components/course-card-home/course-card-home.component';

export const routes:any[] = [
  {
    path: '', component: MainPageComponent
  },
];


@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    ChildComponentsModule,
    CommonChildComponentsModule,
    SwiperModule,
    MatTooltipModule,
    NgOptimizedImage,
    WhyIquantaBestComponent,
    CourseCardHomeComponent
  ],
  declarations: [
    MainPageComponent,
  ],
  entryComponents: [
  ],
  
  providers: [
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class MainPageModule { }